export default `query($articleId: String!) {
      itemStatus(articleId: $articleId) {
        status
      }
  }
`;